<template>
  <div class="dashboard-content">
    <div class="row row-lg" id="tab-box">
      <router-link class="col-6 col-md-3" :to="{ name: 'Orders' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-social-dropbox"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.orders }}</h3>
          </div>
        </div>
      </router-link>
      <router-link :to="{ name: 'Messages' }" class="col-6 col-md-3">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab position-relative">
            <i class="sicon-envelope"></i>
            <span
              class="badge text-light position-absolute translate-middle"
              v-if="unreadMessagesCount"
            >
            {{ unreadMessagesCount }}
            </span>
          </div>
          <div class="feature-box-content">
            <h3>
              {{ translations.messages }}
            </h3>
          </div>
        </div>
      </router-link>
      <router-link class="col-6 col-md-3" :to="{ name: 'Address' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-location-pin"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.addresses }}</h3>
          </div>
        </div>
      </router-link>
      <router-link class="col-6 col-md-3" :to="{ name: 'AccountDetails' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="icon-user-2"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.accountDetails }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'RMA' }">
        <div class="feature-box text-center pb-4">
          <div class="btn-link btn link-to-tab">
            <i class="sicon-note"></i>
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.rmaForm }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'Wishlist' }">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="sicon-heart" />
          </div>
          <div class="feature-box-content">
            <h3>{{ translations.wishlist }}</h3>
          </div>
        </div>
      </router-link>

      <router-link class="col-6 col-md-3" :to="{ name: 'ShoppingCards' }">
        <div class="feature-box text-center pb-4">
          <div>
            <i class="sicon-basket-loaded" />
          </div>
          <div class="feature-box-content">
            <h3>Košarice</h3>
          </div>
        </div>
      </router-link>
    </div>
    <!-- End .row -->
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'Dashboard',
  mixins: [translations],
  methods: {
    setActiveComponent(component) {
      this.$emit('changeTab', component);
    },
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.$store.dispatch('getUnreadMessagesCount');
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    unreadMessagesCount() {
      return this.$store.getters.getUnreadMessagesCount;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #ed7e63;
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
  top: -43px;
  right: -6px;
}
</style>
